module.exports = __webpack_public_path__ + "img/girl-necklace.79ae88f8.jpeg";